function kueSwap(btn) {
  var card = btn.closest('product-block');
  if (!card) return;
  card.querySelectorAll('.kue-swatch').forEach(function(swatch) {
    swatch.classList.remove('active-swatch'); 
  });
  btn.classList.add('active-swatch'); 
  var img   = btn.getAttribute('data-img');
  var img2  = btn.getAttribute('data-img2');
  var title = btn.getAttribute('data-title');
  var url   = btn.getAttribute('data-url');
  var price = btn.getAttribute('data-price');
  var comparePrice = parseFloat(btn.getAttribute('data-compare-price') || 0);
  var salePrice    = parseFloat(btn.getAttribute('data-sale-price') || 0);

  // Swap primary image
  var pi = card.querySelector('.product-block__image--primary img');
  if (pi && img) { pi.src = img; pi.srcset = ''; }

  // Swap secondary hover image
  var si = card.querySelector('.product-block__image--show-on-hover img');
  if (si) {
    if (img2) {
      si.src = img2;
      si.srcset = '';
      si.style.opacity = '';
      si.style.pointerEvents = '';
    } else {
      si.style.opacity = '0';
      si.style.pointerEvents = 'none';
    }
  }

  // Swap title
  var tl = card.querySelector('.product-block__title');
  if (tl) { tl.textContent = title; tl.href = url; }

  // Swap image link
  var ml = card.querySelector('.image-cont .product-link');
  if (ml) ml.href = url;

  // Swap image link
  var dl = card.querySelector('.product-block__detail .product-link');
  if (dl) dl.href = url;

  // Swap image link
  var qt = card.querySelector('.quickbuy-toggle');
  if (qt) qt.href = url;

  // Swap price + recalculate savings %

  var pc = card.querySelector('.product-price.product-price--block');
  if (pc && price) {
    var tmp = document.createElement('textarea');
    tmp.innerHTML = price;
    pc.innerHTML = tmp.value;

    // Append savings % if there's a discount
    // if (comparePrice > 0 && salePrice > 0 && comparePrice > salePrice) {
    //   var percent = Math.round((comparePrice - salePrice) / comparePrice * 100);
    //   var badge = document.createElement('span');
    //   badge.className = 'kue-savings-badge';
    //   badge.textContent = percent + '%';
    //   pc.appendChild(badge);
    // }
  }

  // Update active borders
  btn.closest('div').querySelectorAll('.kue-swatch').forEach(function(s) {
    s.style.borderColor = 'rgba(var(--color-border),1)';
  });
  btn.style.borderColor = 'rgb(var(--color-foreground))';
}
function expandSwatches(trigger) {
if (!trigger) return;
const container = trigger.closest('.kue-swatches-wrap');
if (!container) return;
const hiddenSwatches = container.querySelectorAll('.kue-swatch[hidden]');
hiddenSwatches.forEach(function (btn) {
  btn.removeAttribute('hidden');
});
  trigger.setAttribute('hidden', '');
}